<template>
	<div v-if="show" class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
		<div class="bg-white rounded-xl shadow-lg w-[95%] sm:w-[550px] max-h-[80vh] overflow-hidden">

			<!-- Header -->
			<div class="flex items-center bg-[#F6E2B5] justify-between border-b px-5 py-4">
				<h2 class="text-xl font-semibold text-[#aa6a02] mx-auto">Notifications</h2>

				<button @click="$emit('close')" class="text-[#aa6a02] hover:text-red-600 text-xl">
					<i class="fa-solid fa-xmark"></i>
				</button>
			</div>

			<!-- Notification List -->
			<div class="p-5 space-y-4 overflow-y-auto max-h-[60vh]">

				<div v-for="(item, index) in notifications" :key="index"
					class="bg-gray-100 rounded-lg p-4 flex justify-between items-start hover:bg-gray-200 transition">

					<div>
						<p class="text-sm font-semibold text-gray-800">{{ item.title }}</p>
						<p class="text-sm text-gray-600 mt-1">{{ item.message }}</p>
					</div>

					<span class="text-xs text-gray-500 whitespace-nowrap">{{ item.time }}</span>
				</div>

				<p v-if="notifications.length === 0" class="text-center text-gray-500 text-sm py-5">
					No notifications yet.
				</p>

			</div>

			<!-- Footer Close Button -->
			<!-- <div class="px-5 pb-4">
        <button @click="$emit('close')"
          class="w-full py-2 rounded-lg bg-gradient-to-r from-[#FFD200] to-[#CD7D00] text-white font-medium hover:shadow-md transition">
          Close
        </button>
      </div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'NotificationModal',
	props: {
		show: { type: Boolean, default: false }
	},
	data() {
		return {
			notifications: [
				{ title: "Order #DMRBX0006 Created", message: "Your order has been created successfully", time: "3 weeks ago" },
				{ title: "Order #DMRBX0001 Created", message: "Your order has been created successfully", time: "1 month ago" },
				{ title: "Order #DMRBX0138 Created", message: "Your order has been created successfully", time: "1 month ago" }
			]
		};
	}
};
</script>

<style scoped>
/* smooth scroll */
::-webkit-scrollbar {
	width: 6px;
}

::-webkit-scrollbar-thumb {
	background: #d7d7d7;
	border-radius: 10px;
}
</style>
